/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Saravanan Selvamohan",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Saravanan Selvamohan Portfolio",
    type: "website",
    url: "https://saravananselvamohan.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Saravanan Selvamohan",
  logo_name: "Saravanan Selvamohan",
  subTitle:
    "Software Engineer with 3+ years of IT Experience",
  resumeLink:"https://drive.google.com/file/d/1bIPF8lIugxUvf_NgmmLq2qYROTfk_CDQ/view?usp=sharing",
  portfolio_repository: "https://github.com/saravananselvamohan",
};

const socialMediaLinks = [
 
  {
    name: "Github",
    link: "https://github.com/saravananselvamohan/",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/saravananselvamohan/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/channel/UCLxfkyH77MUOxBw8aiMXy8Q",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:saravananselvamohan@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/__Saravanan",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/saravanansan535",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/saravananselvamohan/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Pega - Certified Senior System Architect",
      fileName: "DataScienceImg",
      imagePath: require("./assests/images/bpmsolution.gif"),
      skills: [
        "⚡ Strong knowledge and experience on PRPC internals and product architecture",
        "⚡ Experience with the Agile delivery methodology",
        "⚡ Deep knowledge of all the Pega capabilities & Pega technology components and exactly know when to use these capabilities",
        "⚡ Configure workflows and Class structure consistent with design and architecture",
        "⚡ Development experience with expertise building User Interfaces using Sections, Harness and HTML Stream rules",
        "⚡ Applicative knowledge of native Javascript, ES6, internal understanding of frameworks like ReactJS",
                      
      ],
      softwareSkills: [
        
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Azure DevOps",
          fontAwesomeClassname: "simple-icons:azuredevops",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Elastic Stack",
          fontAwesomeClassname: "simple-icons:elasticstack",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Web Development",
      fileName: "FullStackImg",
      imagePath: require("./assests/images/webdevelopment.gif"),
      skills: [
        "⚡ Write well designed, testable, efficient code by using best software development practices",
        "⚡ Create website layout/user interface by using standard HTML/CSS practices",
        "⚡ Integrate data from various back-end services and databases",
        "⚡ Experienced with data visualization APIs and JSON (Highcharts, D3.js, Google Charts, etc.)",
        "⚡ Back-End Javascript development using NodeJS, Express, and MySQL",
        "⚡ Experience with development pipelines (e.g. GitHub Actions), test automation, continuous integration and deployment in cloud environments",
        
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
      ],
    },
    {
      title: "Natural Language Processing",
      fileName: "CloudInfraImg",
      imagePath: require("./assests/images/chatbot.gif"),
      skills: [
        "⚡ Experience with deep learning and NLP frameworks(Tensorflow, PyTorch, Transformers, etc.)",
        "⚡ Experience in NLP feature engineering and modeling (e.g., text classification, entity recognition, dependency parsing)",
        "⚡ Experience building search solutions with Elasticsearch",
        "⚡ Knowledge on digital assistants such as Amazon Alexa, Google assistant etc.",
        "⚡ Experience with Open Source Speech Recognition Models",
        "⚡ Certified knowledge of Rasa architecture and best practices for developing mission-critical AI assistants",
      ],
      softwareSkills: [
        {
          skillName: "Google Speech API",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Alexa ",
          fontAwesomeClassname: "simple-icons:amazonalexa",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "Automation",
      fileName: "DesignImg",
      imagePath: require("./assests/images/automation.gif"),
      skills: [
        "⚡ Automation experience with automation frameworks, such as Selenium, TagUI, CasperJS",
        "⚡ Experience with continuous integration (CI) and continuous deployment (CD)",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Selenium",
          fontAwesomeClassname: "simple-icons:selenium",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Javascript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Gitlab",
          fontAwesomeClassname: "simple-icons:gitlab",
          style: {
            color: "#000000",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "StackOverflow",
      iconifyClassname: "simple-icons:stackoverflow",
      style: {
        color: "#F58025",
      },
      profileLink: "https://stackoverflow.com/users/11673591/saravanan-selvamohan",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/saravananselvamohan",
    },
    {
      siteName: "Dev",
      iconifyClassname: "simple-icons:devto",
      style: {
        color: "#323754",
      },
      profileLink: "https://dev.to/saravananselvamohan",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@saravanan343",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/__Saravanan",
    },
   
  ],
};

const degrees = {
  degrees: [
    {
      title: "Bannari Amman Institute of Technology",
      subtitle: "B.E Electrical & Electronics Engineering",
      logo_path: "bit.jpg",
      alt_name: "BIT",
      duration: "2014 - 2018",
      descriptions: [
        "⚡ Academic Project sponsored by TamilNadu State Council for Science and Technology in TamilNadu Engineering Projects 2017-18",
        "⚡ IEEE Student Branch Chairman [Aug 2017 - Mar 2018]",
        "⚡ FIRST CLASS WITH DISTINCTION [Percentage - 81.66 % , CGPA - 8.68]",
      ],
      website_link: "https://www.bitsathy.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Certified System Architect",
      subtitle: "Pega",
      logo_path: "pega.png",
      certificate_link:
        "https://drive.google.com/file/d/1mWhNwD6IjTktmxbbNdBZkTtpTe2gMXYy/view?usp=sharing",
      alt_name: "Certified System Architect",
      color_code: "",
    },
    {
      title: "Certified Senior System Architect",
      subtitle: "Pega",
      logo_path: "pega.png",
      certificate_link:
        "https://drive.google.com/file/d/15I9TP_gmJisdhJSAw8Zp4rwPEpEt4N_c/view?usp=sharing",
      alt_name: "Certified Senior System Architect",
      color_code: "",
    },
    {
      title: "Scrum Fundamentals Certified",
      subtitle: "SCRUMstudy",
      logo_path: "scrum.png",
      certificate_link:
        "https://www.scrumstudy.com/certification/verify?type=SFC&number=623681",
      alt_name: "Scrum Fundamentals Certified",
      color_code: "",
    },
    {
      title: "Rasa Certified Developer",
      subtitle: "Rasa",
      logo_path: "rasa.png",
      certificate_link:
        "https://drive.google.com/file/d/1kgHrYoEoVLAxeLFdf41rhu3staX48YhS/view?usp=sharing",
      alt_name: "Rasa Certified Developer",
      color_code: "",
    },
    {
      title: "Rasa Developer Certification for Advanced Deployment",
      subtitle: "Rasa",
      logo_path: "rasa.png",
      certificate_link:
        "https://drive.google.com/file/d/136hsuM6HqnQEk2JOLzEwRJQR7vHcZ7mv/view?usp=sharing",
      alt_name: "Rasa Developer Certification for Advanced Deployment",
      color_code: "",
    },
    {
      title: "Machine Learning with Python - Level 1",
      subtitle: "IBM",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.credly.com/badges/82323a47-f6a2-4ee7-856d-d48c40229f2d/linked_in_profile",
      alt_name: "IBM",
      color_code: "",
    },
    {
      title: "Build Face Recognition Application",
      subtitle: "GUVI Geek Networks",
      logo_path: "guvi.png",
      certificate_link:
        "https://www.guvi.in/verify-certificate?id=116397vu96o1w7Tc67",
      alt_name: "Build Face Recognition Application",
      color_code: "",
    },
    {
      title: "Robots are coming",
      subtitle: "IBM",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.credly.com/badges/400ea9ce-bfde-4be1-9cb4-c0ac6976996e/linked_in_profile",
      alt_name: "IBM",
      color_code: "",
    },
    {
      title: "Certified HTML/CSS - Basic",
      subtitle: "CutShort",
      logo_path: "cutshort.jpg",
      certificate_link:
        "https://cutshort.io/certificate/36550",
      alt_name: "CutShort",
      color_code: "",
    },
    {
      title: "AWS Cloud Practitioner Essentials",
      subtitle: "Amazon",
      logo_path: "amazon.png",
      certificate_link:
        "https://drive.google.com/file/d/1cRMaWHdus7-AHtKm-zz-quj1DI5OxIyI/view?usp=sharing",
      alt_name: "AWS Cloud Practitioner Essentials",
      color_code: "",
    },
    {
      title: "MongoDB Basics",
      subtitle: "MongoDB",
      logo_path: "mongo.png",
      certificate_link:
        "https://drive.google.com/file/d/1_TSPr7ESWiVkv0uOKbFGRhsi2MxG0Dtp/view?usp=sharing",
      alt_name: "MongoDB Basics",
      color_code: "",
    },
    {
      title: "Business Etiquette",
      subtitle: "TCS",
      logo_path: "tcs.png",
      certificate_link:
        "https://drive.google.com/file/d/1XS4SLLY8K4RV8xKAU3q2ghnAJ-rOqrdn/view?usp=sharing",
      alt_name: "Business Etiquette",
      color_code: "",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "",
  description:
    "Life is a series of experience, each one of which makes us bigger, even though sometimes it is hard to realize this. For the world was built to develop character, and we must learn that the setbacks and griefs which we endure help us in our marching onward.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Engineer",
          company: "Customer Analytics, LLC",
          company_url: "https://customeranalytics.com/",
          logo_path: "customeranalytics.png",
          duration: "Aug 2021 - PRESENT",
          location: "Chennai, TamilNadu",
          description:
            "",
          color: "#0879bf",
        },
        {
          title: "Research & Development Engineer",
          company: "TekClan",
          company_url: "https://tekclansolutions.com/",
          logo_path: "tekclan.png",
          duration: "May 2020 - Jun 2021",
          location: "Chennai, TamilNadu",
          description:
            "",
          color: "#0879bf",
        },
        {
          title: "Associate Software Developer",
          company: "TekClan",
          company_url: "https://tekclansolutions.com/",
          logo_path: "tekclan.png",
          duration: "July 2018 - May 2020",
          location: "Chennai, TamilNadu",
          description:
            "",
          color: "#0879bf",
        },
        {
          title: "Trainee Assitant - Pega",
          company: "TalentSprint",
          company_url: "https://talentsprint.com/",
          logo_path: "talentsprint.jpg",
          duration: "May 2018 - Jun 2018",
          location: "Hyderabad, Telengana",
          description:
            "",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Projects",
      experiences: [
        {
          title: "Compass",
          company: "TekClan",
          company_url: "https://tekclansolutions.com/",
          logo_path: "tekclan.png",
          duration: "Aug 2020 - Jun 2021",
          location: "Chennai, TamilNadu",
          description:
            "1.Configured advanced onboarding and customized automating mundane tasks. 2.Configured CI/CD pipeline empowers all teams to work together efficiently. 3.Create website layout/user interface by using standard HTML/CSS practices. 4.Integrate data from various back-end services and databases.",
          color: "#0879bf",
        },
        {
          title: "NLU HyperAutomation",
          company: "TekClan",
          company_url: "https://tekclansolutions.com/",
          logo_path: "tekclan.png",
          duration: "May 2020 - Aug 2020",
          location: "Chennai, TamilNadu",
          description:
            "1.Built Dynamic Xpath capturing feature using NLU. 2.Implemented Natural Language based Test Case Automation capabilities. 3.Integration TagUI text-based capturing featuring with Selenium.",
          color: "#0879bf",
        },
        {
          title: "Beach - Data Analytics Engine",
          company: "TekClan",
          company_url: "https://tekclansolutions.com/",
          logo_path: "tekclan.png",
          duration: "Jun 2019 - Feb 2020",
          location: "Chennai, TamilNadu",
          description:
            "1.Configured ELK Stack for Data Analytics. 2.Integration of NLU & Speech Recognition with Apache Spark Data Transformation functions. 3.Generating Charts & Graphs for business users’ data. 4.Built NLU Engine to generate machine query from natural language.",
          color: "#0879bf",
        },
        {
          title: "Beacon Purging Project - Pega",
          company: "TekClan",
          company_url: "https://tekclansolutions.com/",
          logo_path: "tekclan.png",
          duration: "Aug 2018 - May 2019",
          location: "Chennai, TamilNadu",
          description:
            "1.Created and configured purge agents and defining the age of work items need to purge. 2.Estimated the purging dependencies of the work items and their related data. 3.Configured REST Services to access the data from the external system. 4.Configured workflows and Class structure consistent with design and architecture. 5.Unit Testing of PRPC rules.",
          color: "#0879bf",
        },
        {
          title: "Trainee Assistant - Pega",
          company: "Talentsprint",
          company_url:
            "https://talentsprint.com/",
          logo_path: "talentsprint.jpg",
          duration: "May 2018 - Jun 2018",
          location: "Hyderabad, Telengana",
          description:
            "1.Provided training in core principles of PEGA PRPC Concepts. 2.Providing Hands on support on PEGA BPM Tool.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Global Ambassador",
          company: "WomenTech Global Conference 2020",
          company_url: "https://www.womentech.net/global-ambassadors/India/Saravanan/Selvamohan",
          logo_path: "womentech.jpg",
          duration: "Jun 2020 - Jul 2020",
          location: "Mountain View, California",
          description:
            "Science and Technology, https://www.womentech.net/global-ambassadors/India/Saravanan/Selvamohan",
          color: "#4285F4",
        },
        {
          title: "Mentor",
          company: "Girlscript Chapter Bilaspur",
          company_url: "https://www.girlscript.tech/home",
          logo_path: "girlscript.png",
          duration: "Jul 2020 - Jul 2021",
          location: "Bilaspur, Chhattisgarh",
          description:
            "Science and Technology",
          color: "#4285F4",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "Nov 2019 - PRESENT",
          location: "Global",
          description:
            "Open Source",
          color: "#4285F4",
        },
        {
          title: "Student Branch Chairman",
          company: "IEEE",
          company_url:
            "https://www.ieee.org/",
          logo_path: "ieee.png",
          duration: "Aug 2017 - Mar 2018",
          location: "Erode, TamilNadu",
          description:
            "Bannari Amman Institute of Technology - Student Chapter",
          color: "#4285F4",
        },
      ],
    },
    {
      title: "Awards",
      experiences: [
        {
          title: "DISRUPTORS Award - R&D",
          company: "TekClan",
          company_url: "https://tekclansolutions.com/",
          logo_path: "tekclan.png",
          duration: "",
          location: "Chennai, TamilNadu",
          description:
            "",
          color: "#0879bf",
        },
        {
          title: "Team Excellence Award - Pega",
          company: "TekClan",
          company_url: "https://tekclansolutions.com/",
          logo_path: "tekclan.png",
          duration: "",
          location: "Chennai, TamilNadu",
          description:
            "",
          color: "#0879bf",
        },
      ],
    }
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact",
    profile_image_path: "saravanan.png",
    description:
      "",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "",
    link: "https://medium.com/@saravananselvamohan",
    avatar_image_path: "blog.gif",
  },
  addressSection: {
    title: "Mail",
    subtitle:
      "saravananselvamohan@gmail.com",
    avatar_image_path: "contact.gif",
    location_map_link: "",
  },
  phoneSection: {
    title: "Mobile",
    subtitle: "+91 96552 92339",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
